import { ActionCreator } from 'redux';
import { Dispatch, ThunkAction } from '../../../../../../../../types/actions';
import { SegmentCardEvent, SegmentCardOptions, segmentTrackAction } from '../../../../../../../../middlewares/segment';
import {
    SegmentCardSourceValue,
    SegmentCardType
} from '../../../../../../../../middlewares/segment/trackEntities/cardEvents';

export const onDropDownOpen: ActionCreator<ThunkAction> = (
    source: SegmentCardType,
    isNewCard: boolean,
) => {
    const action = (
        dispatch: Dispatch,
    ) => {
        if (source !== SegmentCardType.CARD_INPUT) return;

        const option = isNewCard && {
            name: SegmentCardOptions.SOURCE,
            value: SegmentCardSourceValue.CARD_CREATION,
        };
        dispatch(segmentTrackAction(SegmentCardEvent.CARD_PRIORITY_CLICKED, option));
    };
    return action;
};
